// extracted by mini-css-extract-plugin
module.exports = {"card":"GlobalRewardsBenefitsCard_card__tGRBQ","view-link":"GlobalRewardsBenefitsCard_view-link__2N_55","separator":"GlobalRewardsBenefitsCard_separator__9irzZ"};